import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { POST } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

export const CreateQuizContactUs = createAsyncThunk(
  "quizContactUs/create",  
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Quiz_ContactUS.quiz_contact_us, data);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error.message || "Something went wrong");
    }
  }
);

const quizContactUsSlice = createSlice({
  name: "quizContactUs",
  initialState: {
    data: null,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {
    resetQuizContactUsState: (state) => {
      state.data = null;
      state.status = IDS.SLICESTATUS.Idle;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(CreateQuizContactUs.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(CreateQuizContactUs.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data || action.payload;
      })
      .addCase(CreateQuizContactUs.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export const { resetQuizContactUsState } = quizContactUsSlice.actions;
export default quizContactUsSlice.reducer;